import type { ProjectSkillSetting, UpdateProjectSkillInput } from '@/api/projectApi'

export interface ProjectSkillGroup {
  category: string
  skills: ProjectSkillSetting[]
}

export function groupProjectSkillsByCategory(skills: ProjectSkillSetting[] | undefined): ProjectSkillGroup[] {
  const groups = new Map<string, ProjectSkillSetting[]>()
  for (const skill of skills ?? []) {
    const category = skill.category?.trim() || skill.source?.trim() || 'skill'
    const current = groups.get(category) ?? []
    current.push(skill)
    groups.set(category, current)
  }
  return Array.from(groups, ([category, groupedSkills]) => ({ category, skills: groupedSkills }))
}

export function buildProjectSkillToggleBody(enabled: boolean): UpdateProjectSkillInput {
  return { enabled }
}

export function isProjectSkillToggleDisabled(isLoading: boolean, isSaving: boolean): boolean {
  return isLoading || isSaving
}
